import { render, staticRenderFns } from "./PGSContractedServicesComponent.vue?vue&type=template&id=2f311ac0"
import script from "./PGSContractedServicesComponent.vue?vue&type=script&lang=js"
export * from "./PGSContractedServicesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports